import CheckListEditor from './editor';

export default CheckListEditor;
